export default "__VITE_ASSET__WFXJHcOD__"